// extracted by mini-css-extract-plugin
module.exports = {"pr-assistant":"container-queries_pr-assistant__r0MZu"};